import { useLocation, useNavigate } from "react-router-dom";
import './styles/disenodisplay.css';

export default function DisplayCalculo() {
  const navigate = useNavigate();
  const location = useLocation();
  const { nombre, edad, ingreso, tiempo, crecimiento } = location.state || {};

  const formatearMoneda = (valor) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(valor);
  };

  let ingresoMensual = parseFloat(ingreso);
  let crecimientoAnual = 1 + parseFloat(crecimiento) / 100;
  let resultados = [];
  let aporte = 0;
  let edad2 = Number(edad);

  if (ingreso && tiempo) {
    let ingresoActual = ingresoMensual;
    aporte = ingresoMensual;
    edad2 = edad2 + 1;
    for (let i = 1; i <= tiempo; i++) {
      for (let j = 1; j <= 11; j++) {
        ingresoActual += ingresoMensual;
        aporte += ingresoMensual;
      }
      if (i > 1) {
        ingresoActual += ingresoMensual;
        aporte += ingresoMensual;
        edad2 = edad2 + 1;
      }
      ingresoActual *= crecimientoAnual;
      resultados.push({ anio: i, aporte, edad2, monto: ingresoActual.toFixed(2) });
    }
  }

  return (
    <div className="display-container">
      <button
        onClick={() => navigate(-1)}
        className="display-back-button"
      >
        ← Regresar al menu
      </button>

      <h2 className="display-title">Resultado del Cálculo</h2>

      <div className="display-user-info">
        <div className="display-info-item">
          <div className="display-info-label">Nombre:</div>
          <p className="display-info-value">{nombre}</p>
        </div>
        <div className="display-info-item">
          <div className="display-info-label">Edad:</div>
          <p className="display-info-value">{edad}</p>
        </div>
        <div className="display-info-item">
          <div className="display-info-label">Ingreso Mensual:</div>
          <p className="display-info-value">${ingreso}</p>
        </div>
        <div className="display-info-item">
          <div className="display-info-label">Tiempo:</div>
          <p className="display-info-value">{tiempo} años</p>
        </div>
        <div className="display-info-item full-width">
          <div className="display-info-label">Crecimiento Anual:</div>
          <p className="display-info-value">{crecimiento}%</p>
        </div>
      </div>

      <div className="display-projection-section">
        <h3 className="display-projection-title">Proyección del Ingreso por Año</h3>
        
        <table className="display-table">
          <thead>
            <tr>
              <th>Año</th>
              <th>Edad</th>
              <th>Aportación</th>
              <th>Monto Acumulado</th>
            </tr>
          </thead>
          <tbody>
            {resultados.map((resultado) => (
              <tr key={resultado.anio}>
                <td>{resultado.anio}</td>
                <td>{resultado.edad2}</td>
                <td>{formatearMoneda(resultado.aporte)}</td>
                <td>{formatearMoneda(resultado.monto)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="display-disclaimer">
        <span className="display-disclaimer-icon">⚠️</span>
        <strong>Importante:</strong> Los cálculos mostrados son aproximados y tienen fines informativos únicamente. Se recomienda consultar con el asesor financiero para obtener información 
        más precisa y personalizada.
      </div>
    </div>
  );
}


